import React from "react";
import { BrowserRouter as Router, Routes as ReactDomRoutes, Route, Redirect, Navigate } from "react-router-dom";
import { dashboard as dashboardRoutes, auth as authRoutes, unAuthRoutes } from "./index";

import DashboardLayout from "../layouts/Dashboard";
import AuthLayout from "../layouts/Auth";
import Page404 from "../pages/Page404";
import AuthGuard from "../guard/AuthGuard";
import UnAuthGuard from "../guard/UnAuthGuard";


const childRoutes = (Layout, routes, GuardComponent) =>
    routes.map(({ children, path, component: Component }, index) =>
        children ? (
            // Route item with children
            children.map(({ path, component: Component }, index) => (
                <Route
                    key={index}
                    path={path}
                    exact
                    element={<GuardComponent component={<Layout> <Component /> </Layout>} />}
                />
            ))
        ) : (
            // Route item without children
            <Route
                key={index}
                path={path}
                exact
                element={<GuardComponent component={<Layout> <Component /> </Layout>} />}
            />
        )
    );

const Routes = () => (
    <Router basename={process.env.PUBLIC_URL}>
        <ReactDomRoutes>
            {childRoutes(DashboardLayout, dashboardRoutes, AuthGuard)}
            {childRoutes(AuthLayout, authRoutes, AuthGuard)}
            {childRoutes(AuthLayout, unAuthRoutes, UnAuthGuard)}
            <Route
                path="*"
                element={<AuthLayout>
                    <Page404 />
                </AuthLayout>}
            />
            <Route
                path="/"
                element={<Navigate to="/dashboard" replace />}
            />
        </ReactDomRoutes>
    </Router>
);

export default Routes;
